var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTrail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 185,
    viewBox: "0 0 201 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 184.615,
    transform: "translate(0.125 0.192383)",
    fill: "white",
    fillOpacity: 0.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 122.434,
    transform: "translate(0.125 30.9619)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2821 53.8996C42.3387 47.431 44.2527 43.4035 46.0208 41.8157C50.9173 37.4209 57.6874 39.8127 59.1268 40.1553C64.183 41.362 62.539 33.4212 66.8771 31.8072C69.7682 30.7316 72.1459 32.0464 74.0117 35.7513C75.6636 32.2948 78.1808 30.7116 81.5636 30.994C86.6385 31.4214 88.4144 48.4741 95.3877 44.7414C102.363 41.0071 110.913 40.1537 114.566 45.7027C115.355 46.9032 115.658 45.0407 121.027 38.6816C126.397 32.321 131.751 29.5188 142.735 33.2222C147.729 34.9042 151.836 39.464 155.061 46.9001C155.061 57.5135 162.909 63.797 178.602 65.7459C202.145 68.67 183.871 93.8517 155.061 101.226C126.25 108.602 59.9178 112.583 23.9221 93.9489C-0.0749874 81.5286 5.37834 68.1778 40.2805 53.8996H40.2821Z",
    fill: "url(#paint0_linear_281_19896)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3132 147.689C123.287 147.689 142.721 143.213 142.721 137.692C142.721 132.172 123.287 127.696 99.3132 127.696C75.3397 127.696 55.9053 132.172 55.9053 137.692C55.9053 143.213 75.3397 147.689 99.3132 147.689Z",
    fill: "url(#paint1_linear_281_19896)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.675,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.598 150.165C139.96 158.31 28.5563 148.994 16.6989 144.74C10.9276 142.667 5.72552 138.771 1.09423 133.049C0.575881 132.41 0.250069 131.637 0.154438 130.821C0.0588082 130.004 0.197264 129.178 0.553805 128.437C0.910347 127.696 1.47042 127.07 2.16931 126.632C2.8682 126.194 3.67737 125.962 4.50333 125.962H199.176C203.216 136.668 194.357 144.735 172.598 150.165Z",
    fill: "url(#paint2_linear_281_19896)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.622 110.903L117.778 93.6327C117.427 93.2207 116.99 92.8889 116.499 92.6598C116.007 92.4308 115.471 92.31 114.928 92.3057H83.0088C81.9138 92.3057 80.873 92.8056 80.1596 93.6327L65.3149 110.903V120.384H132.622V110.903Z",
    fill: "url(#paint3_linear_281_19896)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.416 120.732L115.423 105.69C115.109 105.335 114.722 105.051 114.288 104.858C113.854 104.665 113.383 104.567 112.908 104.571H85.03C84.073 104.571 83.1377 104.966 82.5142 105.69L69.5215 120.732V128.994H128.416V120.732Z",
    fill: "url(#paint4_linear_281_19896)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.622 131.249C132.622 132.565 132.027 133.749 131.087 134.542L130.896 134.696C130.151 135.258 129.241 135.562 128.306 135.56H69.6329C69.1025 135.56 68.5953 135.465 68.1269 135.289L67.8943 135.196C67.1267 134.857 66.4746 134.303 66.0168 133.602C65.5591 132.901 65.3153 132.083 65.3149 131.248V111.007H81.6454C83.4493 111.007 84.9025 112.484 84.9025 114.275V114.298C84.9025 116.091 86.3729 117.537 88.1767 117.537H109.76C110.627 117.536 111.459 117.194 112.073 116.584C112.686 115.975 113.032 115.149 113.035 114.286C113.035 112.487 114.489 111.007 116.292 111.007H132.624L132.622 131.249Z",
    fill: "url(#paint5_linear_281_19896)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_281_19896",
    x1: 103.549,
    y1: 87.9791,
    x2: 103.549,
    y2: 17.4854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_281_19896",
    x1: 94.7901,
    y1: 147.689,
    x2: 94.7901,
    y2: 127.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96A1C5",
    stopOpacity: 0.373
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_281_19896",
    x1: 100.125,
    y1: 153.396,
    x2: 100.125,
    y2: 120.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_281_19896",
    x1: 98.9686,
    y1: 92.3057,
    x2: 98.9686,
    y2: 104.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_281_19896",
    x1: 106.828,
    y1: 128.994,
    x2: 106.828,
    y2: 103.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8287A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63728D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_281_19896",
    x1: 98.9694,
    y1: 111.007,
    x2: 98.9694,
    y2: 135.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63728D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTrail);
export default __webpack_public_path__ + "static/media/emptyTrail.5a14f553f4a139f7cdd3b5880dccd57a.svg";
export { ForwardRef as ReactComponent };